"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('readingPaneOption', {
    readingPanePosition: null,
    nextSelection: null,
    loadMessageOnLogOn: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-reading-pane-option/lib/store/store.js
// module id = 2813
// module chunks = 2